import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';

export interface DocumentStorageConfig {
  enabled: boolean;
  accountName: string;
  containerName: string;
  connectionString: string;
  hasConnectionString?: boolean;
}

export interface DocumentMigrationStatus {
  total: number;
  unmigrated: number;
  migrated: number;
}

export interface MigrationResult {
  migrated: number;
  errors?: Array<{ id: string; error: string }>;
  message: string;
}

export interface ConnectionTestResult {
  success: boolean;
  message: string;
}

export const documentStorageService = {
  async getConfig(): Promise<DocumentStorageConfig> {
    return httpClient.get<DocumentStorageConfig>(API_CONFIG.ENDPOINTS.DOCUMENT_STORAGE_CONFIG);
  },

  async updateConfig(updates: Partial<Pick<DocumentStorageConfig, 'accountName' | 'containerName' | 'connectionString' | 'enabled'>>): Promise<DocumentStorageConfig> {
    return httpClient.patch<DocumentStorageConfig>(API_CONFIG.ENDPOINTS.DOCUMENT_STORAGE_CONFIG, updates);
  },

  async testConnection(): Promise<ConnectionTestResult> {
    return httpClient.post<ConnectionTestResult>(API_CONFIG.ENDPOINTS.DOCUMENT_STORAGE_TEST, {});
  },

  async getMigrationStatus(): Promise<DocumentMigrationStatus> {
    return httpClient.get<DocumentMigrationStatus>(API_CONFIG.ENDPOINTS.DOCUMENT_STORAGE_MIGRATION_STATUS);
  },

  async migrateDocuments(batchSize = 10): Promise<MigrationResult> {
    return httpClient.post<MigrationResult>(API_CONFIG.ENDPOINTS.DOCUMENT_STORAGE_MIGRATE, { batchSize });
  },
};
